import { Collapse, Grid, Tooltip, IconButton } from "@material-ui/core";
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Fragment, useState } from "react";
import { TimeframeInvoiceActivityColumns, TimeframeInvoiceVehicleColumns } from "../../storageInvoiceConsts";
import { storageInvoiceItemizedStyles } from "./style";
import {
    isBundleService,
    getBundleActivityCellValue,
    getBundleDiscountCellValue,
    normalizeMechanicalRows,
    getInvoiceSummaryCellValue
} from "./storageInvoiceItemizedUtils";

const PENDING_BUNDLE_TOOLTIP = 'Bundle is not complete yet, so no charge is applied yet.';

const StorageInvoiceDetailsItemized = ({ invoice, expanded }) => {
    const classes = storageInvoiceItemizedStyles();
    const [expandedBundles, setExpandedBundles] = useState({});

    const toggleBundle = (bundleKey) => {
        setExpandedBundles((current) => ({
            ...current,
            [bundleKey]: !current[bundleKey],
        }));
    };

    const storageInvoiceActivities = invoice?.storageInvoiceActivities ?? [];

    const mechanicalRows = normalizeMechanicalRows(storageInvoiceActivities);


    return (
        <>
            <Collapse in={expanded} timeout="auto" unmountOnExit className={classes.collapseWrapper}>
                <Grid container direction="column">
                    {!!invoice?.storageInvoiceVehicles?.length && <>
                        <Grid item className={classes.sectionTitle} >Storage</Grid>
                        <Grid item container className={classes.detailsWrapper} spacing={2}>
                            {TimeframeInvoiceVehicleColumns?.map((col, index) =>
                                <Grid className={classes.column} xs={col.width ?? 1} item container direction='column' key={`col_${index}`}>
                                    <Grid className={classes.column}>{col?.name}</Grid>
                                </Grid>)}
                        </Grid>
                        {invoice?.storageInvoiceVehicles?.map((v, rowIndex) => <Grid key={`storage_${v?.id ?? v?.vehicleId ?? rowIndex}`} item container className={classes.detailsWrapper} spacing={2}>
                            {TimeframeInvoiceVehicleColumns?.map((col, index) =>
                                <Grid className={classes.field} xs={col.width ?? 1} item container direction='column' key={`col_${index}`}>
                                    {col.component ? col.component(v) : v?.[col.key] ?? 0}
                                </Grid>)}

                        </Grid>)}
                    </>}
                    {!!mechanicalRows?.length && <>
                        <Grid item className={classes.sectionTitle} >Mechanical Work</Grid>
                        <Grid item container className={classes.detailsWrapper} spacing={2}>
                            {TimeframeInvoiceActivityColumns?.map((col, index) =>
                                <Grid className={classes.column} xs={col.width ?? 1} item container direction='column' key={`col_${index}`}>
                                    <Grid className={classes.column}>{col?.name}</Grid>
                                </Grid>)}
                        </Grid>
                        {mechanicalRows?.map((row, rowIndex) => {
                            const summary = row?.summary;
                            const bundleActivities = row?.bundleActivities ?? [];
                            const bundleDiscount = row?.bundleDiscount;
                            const isBundle = isBundleService(summary, bundleActivities);
                            const bundleKey = summary?.activityLogBundleId ?? summary?.id ?? summary?.activityLogId ?? rowIndex;
                            const isBundleExpanded = !!expandedBundles[bundleKey];

                            return (
                                <Fragment key={`activity_group_${summary?.id ?? summary?.activityLogId ?? rowIndex}`}>
                                    <Grid
                                        key={`activity_${summary?.id ?? summary?.activityLogId ?? rowIndex}`}
                                        item
                                        container
                                        className={`${classes.detailsWrapper} ${isBundle ? classes.bundleSummaryRow : ''}`}
                                        spacing={2}
                                    >
                                        {TimeframeInvoiceActivityColumns?.map((col, index) =>
                                            <Grid className={classes.field} xs={col.width ?? 1} item container direction='column' key={`col_${index}`}>
                                                {col?.key === 'vin' ? (
                                                    <div className={classes.bundleVinCell}>
                                                        {isBundle ? (
                                                            <span className={classes.bundleToggleIcon}>
                                                                <IconButton
                                                                    className={classes.bundleToggleButton}
                                                                    onClick={() => toggleBundle(bundleKey)}
                                                                    aria-label={isBundleExpanded ? 'Collapse bundle' : 'Expand bundle'}
                                                                    size="small"
                                                                >
                                                                    {isBundleExpanded ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
                                                                </IconButton>
                                                            </span>
                                                        ) : (
                                                            <span className={classes.bundleToggleIcon} style={{ visibility: 'hidden' }}>
                                                                <IconButton className={classes.bundleToggleButton} size="small" disabled>
                                                                    <ExpandMoreIcon fontSize='small' />
                                                                </IconButton>
                                                            </span>
                                                        )}
                                                        <span>{getInvoiceSummaryCellValue(summary, col, isBundle, { classes, pendingTooltip: PENDING_BUNDLE_TOOLTIP })}</span>
                                                    </div>
                                                ) : col?.key === 'activityName' && isBundle ? (
                                                    <div className={classes.bundleNameCell}>
                                                        <span>{getInvoiceSummaryCellValue(summary, col, isBundle, { classes, pendingTooltip: PENDING_BUNDLE_TOOLTIP })}</span>
                                                        {summary?.isBundlePending && (
                                                            <Tooltip title={PENDING_BUNDLE_TOOLTIP}>
                                                                <span className={classes.pendingBadge}>Pending</span>
                                                            </Tooltip>
                                                        )}
                                                    </div>
                                                ) : getInvoiceSummaryCellValue(summary, col, isBundle, { classes, pendingTooltip: PENDING_BUNDLE_TOOLTIP })}
                                            </Grid>)}

                                    </Grid>
                                    {isBundle &&
                                        <Collapse in={isBundleExpanded} timeout="auto" unmountOnExit>
                                            {bundleActivities?.map((bundleActivity, bundleActivityIndex) =>
                                                <Grid key={`bundle_activity_${summary?.id ?? summary?.activityLogId ?? rowIndex}_${bundleActivity?.id ?? bundleActivity?.activityLogId ?? bundleActivityIndex}`} item container className={`${classes.detailsWrapper} ${classes.bundleNestedRow}`} spacing={2}>
                                                    {TimeframeInvoiceActivityColumns?.map((col, colIndex) =>
                                                        <Grid className={classes.field} xs={col.width ?? 1} item container direction='column' key={`bundle_col_${colIndex}`}>
                                                            {col?.key === 'vin' ? (
                                                                <div className={classes.bundleChildVinCell}>{getBundleActivityCellValue(bundleActivity, col, summary?.isBundlePending)}</div>
                                                            ) : getBundleActivityCellValue(bundleActivity, col, summary?.isBundlePending)}
                                                        </Grid>)}
                                                </Grid>
                                            )}
                                            {!summary?.isBundlePending && typeof bundleDiscount === 'number' &&
                                                <Grid key={`bundle_discount_${summary?.id ?? summary?.activityLogId ?? rowIndex}`} item container className={`${classes.detailsWrapper} ${classes.bundleDiscountRow}`} spacing={2}>
                                                    {TimeframeInvoiceActivityColumns?.map((col, colIndex) =>
                                                        <Grid className={classes.field} xs={col.width ?? 1} item container direction='column' key={`bundle_discount_col_${colIndex}`}>
                                                            {getBundleDiscountCellValue(bundleDiscount, col)}
                                                        </Grid>)}
                                                </Grid>
                                            }
                                        </Collapse>
                                    }
                                </Fragment>
                            );
                        })}
                    </>}
                </Grid>
            </Collapse>
        </>
    )
}

export default StorageInvoiceDetailsItemized;